"use strict";

var isUndefined = require('lodash/isUndefined');

var uniq = require('lodash/uniq');

var flatten = require('lodash/flatten');

var _require = require('./util'),
    getVersion = _require.getVersion;

var _require2 = require('./algorithms'),
    productPriceCalculator = _require2.productPriceCalculator,
    printingAmountCalculator = _require2.printingAmountCalculator;

var _require3 = require('./util'),
    validateOptions = _require3.validateOptions,
    gatherValues = _require3.gatherValues;
/**
 * Handles retrieval and execution of price composables.
 *
 * @module ShinePricing
 */


var Pricing = function Pricing() {
  var _instance;

  function init(opts) {
    // let's first check that the right options have been passed in.
    // if not, we can let the user know what they need to do.
    validateOptions(opts);
    var options = opts;

    function setPriceTableVersions(params) {
      var _this = this;

      var productType = this.type;
      var priceTableNames;

      if (isUndefined(options.priceTableAssignments[productType])) {
        throw new Error("product settings missing for ".concat(productType));
      } // here we check for a priceTableAssignments field called 'all'.
      // If it does not exist, we use the union of all tables listed
      // in all child components.


      var possiblePriceTableNames = uniq(flatten(gatherValues(options.priceTableAssignments[productType])));

      if (isUndefined(options.priceTableAssignments[productType].all)) {
        priceTableNames = possiblePriceTableNames;
      } else {
        priceTableNames = options.priceTableAssignments[productType].all;
      }

      priceTableNames.forEach(function (priceTableName) {
        try {
          getVersion(options.priceTables[priceTableName]);
        } catch (error) {
          debugger;
        }

        _this["".concat(priceTableName, "_version")] = params["".concat(priceTableName, "_version")] == null ? getVersion(options.priceTables[priceTableName]) : params["".concat(priceTableName, "_version")];

        if (params["".concat(priceTableName, "_version")] != null && _this["".concat(priceTableName, "_version")] !== params["".concat(priceTableName, "_version")]) {
          console.warn("".concat(priceTableName, "_version was not null but was set to"), _this["".concat(priceTableName, "_version")], ' instead of ', params["".concat(priceTableName, "_version")]);
        }
      });
    }
    /**
     * returns the price of a Product
     * @param {Product} product
     */


    function calculatePrice(product) {
      if (isUndefined(options.priceTableAssignments[product.type])) {
        throw new Error("product settings missing for ".concat(product.type));
      }

      return productPriceCalculator(product, options).sum;
    }
    /**
     * returns the price breakdown for a Product
     * @param {Product} product
     */


    function calculateSplitFee(product) {
      if (isUndefined(options.priceTableAssignments[product.type])) {
        throw new Error("product settings missing for ".concat(product.type));
      }

      return productPriceCalculator(product, options).split_fee;
    }
    /**
     * returns the price breakdown for a Product
     * @param {Product} product
     */


    function calculatePriceBreakdown(product) {
      if (isUndefined(options.priceTableAssignments[product.type])) {
        throw new Error("product settings missing for ".concat(product.type));
      }

      return productPriceCalculator(product, options).breakdown;
    }

    function calculatePrintingAmount(order, decisionTree) {
      return printingAmountCalculator(order, decisionTree, options);
    }

    return {
      setPriceTableVersions: setPriceTableVersions,
      calculatePrice: calculatePrice,
      calculateSplitFee: calculateSplitFee,
      calculatePriceBreakdown: calculatePriceBreakdown,
      calculatePrintingAmount: calculatePrintingAmount
    };
  }

  return {
    /**
     * initialize
     * @param {*} opts
     * @instance
     * @example
     * import { ShinePricing } from 'shine-products-v2';
     * ShinePricing.initialize(opts);
     */
    initialize: function initialize(opts) {
      _instance = init(opts);
    },

    /**
     * SINGLETON INSTANCE
     * @instance
     * @example
     * import { ShinePricing } from 'shine-products-v2';
     * ShinePricing.instance()
     * // => {
     * //  updatePriceTables
     * //  setPriceTableVersions
     * //  calculatePrice
     * //  calculateSplitFee
     * //  calculatePriceBreakdown
     * //  getPriceTable
     * // }
     */
    instance: function instance() {
      if (!_instance) {
        throw new Error('You must first initialize');
      }

      return _instance;
    }
  };
}();

module.exports = Pricing;